import {
    SETTINGS_PROCESSING_ORDERS_DELIVERY_AUTOMATION_ENABLED_SLUG,
    SETTINGS_PROCESSING_ORDERS_REFUNDS_AUTOMATION_ENABLED_SLUG,
} from '../../constants';
import { useSettingsFactory } from './useSettingsFactory';

export const useSettingsProcessing = () =>
    useSettingsFactory({
        ordersDeliveryAutomationEnabled: {
            path: SETTINGS_PROCESSING_ORDERS_DELIVERY_AUTOMATION_ENABLED_SLUG,
        },
        ordersRefundsAutomationEnabled: {
            path: SETTINGS_PROCESSING_ORDERS_REFUNDS_AUTOMATION_ENABLED_SLUG,
        },
    });
